import { authApiHandler } from '../services/authApi'
import { AuthConfig } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'
import { AccessTokenData } from '../types/tokenTypes'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (contactId: number): Promise<boolean> => {
    const provider = cookies.getProvider()
    const idToken = cookies.getIdToken()
    const refreshToken = cookies.getRefreshToken()
    const isPunchout = provider === 'dustin_punchout'

    const isValidIdToken = token.isValidToken(idToken)

    if (!isValidIdToken) {
      if (!refreshToken) {
        cookies.clearTokens()
        return false
      }

      if (!provider) {
        cookies.clearTokens()
        return false
      }

      const tokens = await authApi.refreshTokens(refreshToken, provider, contactId)
      if (!tokens) {
        cookies.clearTokens()
        return false
      }

      const newContactId =
        token.getToken<AccessTokenData>(tokens.micrositeToken)?.contact?.contact_id ?? 0

      cookies.setIdToken(tokens.idToken, isPunchout)
      cookies.setRefreshToken(tokens.refreshToken, isPunchout)
      cookies.setAccessToken(tokens.micrositeToken, isPunchout)

      cookies.setContactId(newContactId, isPunchout)

      return newContactId > 0
    }

    const accessToken = await authApi.getAccessToken(idToken, contactId)

    if (!accessToken) {
      cookies.clearTokens()
      return false
    }

    const newContactId = token.getToken<AccessTokenData>(accessToken)?.contact?.contact_id ?? 0

    cookies.setAccessToken(accessToken, isPunchout)
    cookies.setContactId(newContactId, isPunchout)

    return newContactId > 0
  }
}
